module.exports = __webpack_public_path__ + "img/female_avatar-min.26811d9e.jpg";